<template>
  <b-form-group>
    <div v-if="filter.type === 'checkbox'">
      <b-form-checkbox :id="'filter-' + filter.name" v-model="quickFilters[filter.name]">{{filter.label}}</b-form-checkbox>
    </div>
    <div v-if="filter.type === 'checkbox-group'">
      <label :for="'filter-' + filter.name">{{filter.label}}</label>
      <b-form-checkbox-group v-if="filter.options" :stacked="filter.stacked || false" :id="'filter-' + filter.name" v-model="quickFilters[filter.name]" :options="filter.options"></b-form-checkbox-group>
    </div>
    <div v-if="filter.type === 'radio-group' && filter.options.length > 0">
      <label :for="'filter-' + filter.name">{{filter.label}}</label>
      <b-form-radio-group v-if="filter.options" :stacked="filter.stacked || false" :id="'filter-' + filter.name" v-model="quickFilters[filter.name]" :options="filter.options"></b-form-radio-group>
    </div>
    <div v-if="filter.type === 'select' && filter.options.length > 0">
      <label :for="'filter-' + filter.name">{{filter.label}}</label>
      <b-form-select size="sm" v-if="filter.options" :id="'filter-' + filter.name" v-model="quickFilters[filter.name]" :options="filter.options"></b-form-select>
    </div>
    <div v-if="filter.type === 'text'">
      <label :for="'filter-' + filter.name">{{filter.label}}</label>
      <input :id="'filter-' + filter.name" v-model.lazy="quickFilters[filter.name]" type="text" class="col-12 form-control">
    </div>
    <div v-if="filter.type === 'textarea'">
      <label :for="'filter-' + filter.name">{{filter.label}}</label>
      <textarea :id="'filter-' + filter.name" v-model.lazy="quickFilters[filter.name]" class="mb-2 col-12 form-control" />
    </div>
    <div v-if="filter.type === 'address-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <address-autocomplete :ref="'ac' + filter.name" @selected="onSearchAddressSelected($event, filter.name)" :static-items="filter.staticItems || false" :min-character="filter.minCharacter || 4" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <p class="my-2" v-if="quickFilters[filter.name] && quickFilters[filter.name].formatted_address">
        {{quickFilters[filter.name].formatted_address}}
        <b-button size="sm" variant="danger" @click.stop="resetAddressAc(filter)" v-b-tooltip.hover :title="$gettext('Delete Address')" style="padding: 2px 3px; line-height: 1">
          <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 13px; vertical-align: middle" />
        </b-button>
      </p>
    </div>
    <div v-if="filter.type === 'geofence-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <geofence-autocomplete :ref="'ac' + filter.name" @selected="onSearchGeofenceSelected($event, filter.name)" :static-items="filter.staticItems || false" :min-character="filter.minCharacter || 4" :restrict-to-levels="filter.restricToLevels || [0]" :restrict-to="filter.restricTo || null" v-if="!quickFilters[filter.name] || !quickFilters[filter.name].external_id" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <p class="my-2" v-else>
        <b-button size="sm" variant="danger" @click.stop="resetGeofenceAc(filter)" v-b-tooltip.hover :title="$gettext('Delete Geofence')" style="padding: 2px 3px; line-height: 1">
          <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 13px; vertical-align: middle" />
        </b-button>
        <strong>{{quickFilters[filter.name].external_id || ''}}</strong> {{quickFilters[filter.name].name}} {{ quickFilters[filter.name].reference_location ? `(${quickFilters[filter.name].reference_location})` : ''}}
      </p>
    </div>
    <div v-if="filter.type === 'commodity-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <commodity-autocomplete :ref="'ac' + filter.name" @selected="onSearchCommoditySelected($event, filter.name)" :static-items="filter.staticItems || false" :min-character="filter.minCharacter || 4" :restrict-to-levels="filter.restricToLevels || [0]" :restrict-to="filter.restricTo || null" v-if="!quickFilters[filter.name] || !quickFilters[filter.name].external_id" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <p class="my-2" v-else>
        <b-button size="sm" variant="danger" @click.stop="resetCommodityAc(filter)" v-b-tooltip.hover :title="$gettext('Delete Commodity')" style="padding: 2px 3px; line-height: 1">
          <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 13px; vertical-align: middle" />
        </b-button>
        <strong>{{quickFilters[filter.name].external_id || ''}}</strong> ({{quickFilters[filter.name].reference}})
      </p>
    </div>
    <div v-if="filter.type === 'vehicle-type-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <vehicle-type-autocomplete :remote="filter.remote || false" :ref="'ac' + filter.name" @selected="onSearchVehicleTypeSelected($event, filter.name)" :static-items="filter.staticItems || false" :min-character="filter.minCharacter || 4" :restrict-to-levels="filter.restricToLevels || [0]" :restrict-to="filter.restricTo || null" v-if="!quickFilters[filter.name] || !quickFilters[filter.name].name" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <p class="my-2" v-else>
        <b-button size="sm" variant="danger" @click.stop="resetVehicleTypeAc(filter)" v-b-tooltip.hover :title="$gettext('Delete Vehicle Type')" style="padding: 2px 3px; line-height: 1">
          <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 13px; vertical-align: middle" />
        </b-button>
        <strong>{{quickFilters[filter.name].name || ''}}</strong>
        <span v-if="quickFilters[filter.name].typeGroup">({{ quickFilters[filter.name].typeGroup }})</span>
      </p>
    </div>
    <div v-if="filter.type === 'order-service-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <order-service-autocomplete :ref="'ac' + filter.name" @selected="onSearchItemSelected($event, filter.name)" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <b-badge v-for="(item, index) in quickFilters[filter.name]" :key="index" class="mr-1">
        {{ item.external_id }} <b-badge variant="danger" href="#" @click.prevent="removeItemFromFilters(index, filter.name)">×</b-badge>
      </b-badge>
    </div>
    <div v-if="filter.type === 'company-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <company-autocomplete :ref="'ac' + filter.name" @selected="onSearchItemSelected($event, filter.name)" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <b-badge v-for="(item, index) in quickFilters[filter.name]" :key="index" class="mr-1">
        {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeItemFromFilters(index, filter.name)">×</b-badge>
      </b-badge>
    </div>
    <div v-if="filter.type === 'tag-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <tag-autocomplete :ref="'ac' + filter.name" @selected="onSearchItemSelected($event, filter.name)" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <b-badge v-for="(item, index) in quickFilters[filter.name]" :key="index" class="mr-1">
        {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeItemFromFilters(index, filter.name)">×</b-badge>
      </b-badge>
    </div>
    <div v-if="filter.type === 'user-autocomplete'">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}}</label>
      <user-autocomplete :placeholder="filter.placeholder || ''" :ref="'ac' + filter.name" :restrict-to-roles="filter.restrictToRoles || []" @selected="onSearchItemSelected($event, filter.name)" v-bind="filter.props || void(0)" v-on="filter.on || void(0)" />
      <b-badge v-for="(item, index) in quickFilters[filter.name]" :key="index" class="mr-1">
        {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeItemFromFilters(index, filter.name)">×</b-badge>
      </b-badge>
    </div>
    <div v-if="filter.type === 'daterange' && quickFilters[filter.name]">
      <label v-if="filter.label" :for="'filter-' + filter.name">{{filter.label}} </label><label v-show="quickFilters[filter.name].dateRangeActive === true">&nbsp;[<a href="#" @click.prevent="resetDateRange" v-translate>reset range</a>]</label>
      <date-range-picker
        :ref="'filter-' + filter.name"
        :id="'filter-' + filter.name"
        v-model="quickFilters[filter.name]"
        @update="dateRange.dateRangeActive = true; onDateRangeSelected()"
        :locale-data="{...dateRange.locale}"
        :opens="filter.opens || dateRange.opens"
        class="mb-2 w-100"
        :ranges="filter.ranges || dateRange.ranges"
      >
        <template #input="">
          <div style="top: .75em;position:relative">
            <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
            <span v-if="!quickFilters[filter.name].dateRangeActive" style="vertical-align: middle">...</span>
            <span v-else style="vertical-align: middle">{{moment(quickFilters[filter.name].startDate).format('L')}} - {{moment(quickFilters[filter.name].endDate).format('L')}}</span>
          </div>
        </template>
      </date-range-picker>
    </div>
  </b-form-group>
</template>

<script>
import AddressesMixin from '@/mixins/address.mixin'
import AddressAutocomplete from '@/components/Autocompletes/AddressAutocomplete'
import GeofenceAutocomplete from '@/components/Autocompletes/GeofenceAutocomplete'
import CommodityAutocomplete from '@/components/Autocompletes/CommodityAutocomplete'
import VehicleTypeAutocomplete from '@/components/Autocompletes/VehicleTypeAutocomplete'
import OrderServiceAutocomplete from '@/components/Autocompletes/OrderServiceAutocomplete'
import CompanyAutocomplete from '@/components/Autocompletes/CompanyAutocomplete'
import TagAutocomplete from '@/components/Autocompletes/TagAutocomplete'
import UserAutocomplete from '@/components/Autocompletes/UserAutocomplete'
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'QuickFiltersFields',
  components: {
    AddressAutocomplete,
    GeofenceAutocomplete,
    CommodityAutocomplete,
    VehicleTypeAutocomplete,
    OrderServiceAutocomplete,
    CompanyAutocomplete,
    TagAutocomplete,
    UserAutocomplete,
    DateRangePicker
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
      required: true
    },
    quickFilters: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      dateRange: {
        ranges: this.filter.ranges || {
          [this.$gettext('Today')]: [new Date(this.moment().startOf('day').format('YYYY-MM-DD')), new Date(this.moment().endOf('day').format('YYYY-MM-DD'))],
          [this.$gettext('Yesterday')]: [new Date(this.moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD'))], // [this.moment().startOf('day').toDate(), this.moment().subtract(1, 'days').endOf('day').toDate()],
          [this.$gettext('Last 7 days')]: [new Date(this.moment().subtract(6, 'day').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().endOf('day').format('YYYY-MM-DD'))], // [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()]
          [this.$gettext('Tomorrow')]: [new Date(this.moment().add(1, 'days').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().add(1, 'days').endOf('day').format('YYYY-MM-DD'))],
          [this.$gettext('Next 7 days')]: [new Date(this.moment().startOf('day').format('YYYY-MM-DD')), new Date(this.moment().add(6, 'days').endOf('day').format('YYYY-MM-DD'))] // [this.moment().add(0, 'day').startOf('day').toDate(), this.moment().add(6, 'day').endOf('day').toDate()]
        },
        opens: 'right',
        locale: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: this.$gettext('Apply'),
          cancelLabel: this.$gettext('Cancel'),
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: this.moment.weekdaysMin(),
          monthNames: this.moment.monthsShort(),
          firstDay: this.moment().day(0) === this.moment().local().weekday(0) ? 0 : 1,
          showWeekNumbers: false
        },
        range: {
          startDate: this.moment().toDate(),
          endDate: this.moment().toDate()
        },
        dateRangeActive: false
      }
    }
  },
  mixins: [
    AddressesMixin
  ],
  created() {
    if (this.filter.type === 'daterange' && !this.filter.value.dateRangeActive && !this.quickFilters[this.filter.name]) {
      this.resetDateRange()
    }
    this.$root.$on('dateRangeSelected', this.oneDateRangeSelected)
  },
  methods: {
    // Autocompletes methods
    async onSearchAddressSelected(event, filter) {
      await this.checkPlace(event)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.quickFilters[filter] = { id: this.theCheckedAddress.id, formatted_address: this.theCheckedAddress.formatted_address }
          this.$refs['ac' + filter].searchQuery = ''
        }
        this.theCheckedAddress = {}
      })
    },
    resetAddressAc(filter) {
      this.quickFilters[filter.name] = {}
      setTimeout(function () {
        if (this.$refs['ac' + filter.name]) {
          this.$refs['ac' + filter.name].$children[0].$el.children[0].focus()
        } else {
          this.resetAddressAc(filter)
        }
      }.bind(this), 100)
    },
    onSearchGeofenceSelected(event, filter) {
      this.quickFilters[filter] = {
        external_id: event.external_id,
        name: event.name,
        reference_location: event.reference_location
      }
      this.$refs['ac' + filter].searchQuery = ''
    },
    resetGeofenceAc(filter) {
      this.quickFilters[filter.name] = {}
      setTimeout(function () {
        if (this.$refs['ac' + filter.name]) {
          this.$refs['ac' + filter.name].$children[0].$el.children[0].focus()
        } else {
          this.resetGeofenceAc(filter)
        }
      }.bind(this), 100)
    },
    onSearchCommoditySelected(event, filter) {
      this.quickFilters[filter] = {
        id: event.id,
        external_id: event.external_id,
        reference: event.reference
      }
      this.$refs['ac' + filter].searchQuery = ''
    },
    resetCommodityAc(filter) {
      this.quickFilters[filter.name] = {}
      setTimeout(function () {
        if (this.$refs['ac' + filter.name]) {
          this.$refs['ac' + filter.name].$children[0].$el.children[0].focus()
        } else {
          this.resetCommodityAc(filter)
        }
      }.bind(this), 100)
    },
    onSearchVehicleTypeSelected(event, filter) {
      console.log(event)
      this.quickFilters[filter] = {
        id: event.id,
        name: event.name
      }
      if (event.vehicle_type_group && event.vehicle_type_group.id) {
        this.quickFilters[filter].typeGroup = event.vehicle_type_group.external_id || event.vehicle_type_group.reference
      }
      this.$refs['ac' + filter].searchQuery = ''
    },
    resetVehicleTypeAc(filter) {
      this.quickFilters[filter.name] = {}
      setTimeout(function () {
        if (this.$refs['ac' + filter.name]) {
          this.$refs['ac' + filter.name].$children[0].$el.children[0].focus()
        } else {
          this.resetVehicleTypeAc(filter)
        }
      }.bind(this), 100)
    },
    onSearchItemSelected(event, filter) {
      const item = {
        id: event.id,
        name: event.name
      }
      if (event.external_id) {
        item.external_id = event.external_id
      }
      if (event.reference) {
        item.reference = event.reference
      }
      this.quickFilters[filter].push(item)
      this.$refs['ac' + filter].searchQuery = ''
    },
    removeItemFromFilters(index, filter) {
      this.quickFilters[filter].splice(index, 1)
    },
    // Date Ranges methods
    onDateRangeSelected() {
      this.$root.$emit('dateRangeSelected', this.filter.name)
      this.quickFilters[this.filter.name].dateRangeActive = this.dateRange.dateRangeActive
    },
    resetDateRange() {
      this.quickFilters[this.filter.name] = this.filter.value || {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate(),
        dateRangeActive: false
      }
    },
    fullResetDateRange() {
      this.quickFilters[this.filter.name] = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate(),
        dateRangeActive: false
      }
    },
    oneDateRangeSelected(name) {
      if (this.filter.type === 'daterange' && name !== this.filter.name) {
        this.fullResetDateRange()
      }
    }
  }
}
</script>
